import { useState, useEffect, useRef } from "react";
import client from "../../api/client";
import { Search, Loader2 } from "lucide-react";

export default function SchoolAutocomplete({ value, onSelect }) {
  const [query, setQuery] = useState(value?.name || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    setQuery(value?.name || "");
  }, [value]);

  useEffect(() => {
    const handler = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (!open) return;
    const q = query.trim();
    if (q.length < 2) {
      setResults([]);
      return;
    }
    setLoading(true);
    const t = setTimeout(() => {
      client
        .get("/schools/search", { params: { q } })
        .then((res) => setResults(res.data))
        .finally(() => setLoading(false));
    }, 300);
    return () => clearTimeout(t);
  }, [query, open]);

  return (
    <div className="relative" ref={boxRef} data-testid="school-autocomplete">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <input
          data-testid="school-search-input"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
          placeholder="Hledat školu (název, město, IČO)…"
          className="w-full h-10 pl-9 pr-3 rounded-md border border-input bg-background text-sm outline-none focus:ring-2 focus:ring-ring/20 focus:border-ring"
        />
        {loading && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-muted-foreground" />}
      </div>
      {open && results.length > 0 && (
        <div className="absolute z-20 mt-1 w-full bg-popover border border-border rounded-md shadow-md max-h-72 overflow-auto">
          {results.map((s) => (
            <button
              key={s.id}
              type="button"
              data-testid={`school-option-${s.id}`}
              onClick={() => {
                onSelect(s);
                setQuery(s.name);
                setOpen(false);
              }}
              className="w-full text-left px-3 py-2 hover:bg-secondary text-sm border-b border-border/60 last:border-0"
            >
              <div className="font-medium">{s.name}</div>
              <div className="text-xs text-muted-foreground">
                {[s.city, s.zip, s.ico && `IČO ${s.ico}`].filter(Boolean).join(" · ")}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
